import React from "react";
import CrudModule from "@/components/admin/CrudModule";
import { crudFor } from "@/services/dataClient";
import { Badge } from "@/components/common/Primitives";

const seedMedia = [
  {
    id: "seed-med-1",
    title: "Sabha Day 2026 Souvenir (PDF)",
    media_type: "pdf",
    file_url: "#",
    created_at: "2026-05-01",
  },
  {
    id: "seed-med-2",
    title: "BCS Crest Logo",
    media_type: "image",
    file_url: "https://customer-assets.emergentagent.com/job_bombay-sabha/artifacts/z77ljcgs_bcsabha-logo.png",
    created_at: "2026-01-10",
  },
  {
    id: "seed-med-3",
    title: "Aarey plantation drive — highlights video",
    media_type: "video",
    file_url: "#",
    created_at: "2025-07-10",
  },
];

export const mediaCrud = crudFor("media", seedMedia);

export default function AdminMediaPage() {
  return (
    <CrudModule
      title="Media Library"
      description="Central registry of images, videos, PDFs and downloadable documents. Paste hosted URLs (Supabase Storage, CDN, etc.) and reuse them across events, forums and units."
      crud={mediaCrud}
      searchKeys={["title", "media_type"]}
      columns={[
        {
          key: "title",
          label: "Item",
          render: (r) => (
            <div className="flex items-center gap-3">
              {r.media_type === "image" && r.file_url && r.file_url !== "#" && (
                <img src={r.file_url} alt="" className="h-9 w-9 rounded object-cover border border-gray-100" />
              )}
              <span>{r.title}</span>
            </div>
          ),
        },
        { key: "media_type", label: "Type", render: (r) => <Badge tone="maroon">{r.media_type}</Badge> },
        { key: "file_url", label: "URL" },
      ]}
      fields={[
        { name: "title", label: "Title", type: "text", required: true },
        { name: "media_type", label: "Type", type: "select", options: ["image", "video", "pdf", "document"], required: true },
        { name: "file_url", label: "File URL", type: "text", required: true, hint: "Hosted URL — e.g. a Supabase Storage public URL" },
      ]}
    />
  );
}
